module.exports = __webpack_public_path__ + "static/zoppay@2x-2980ea98265231f78a209459252a2e39.png";